var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('OzBaseButton',{class:[
    _vm.colorClasses,
    `dark:bg-dark-ui-200`,
    'text-dark-text-100',
    'dark:text-light-text-100',
    'h-12',
    'tablet-portrait:h-14',
    'flex',
    'flex-row',
    'flex-auto',
    'items-center',
    'first:rounded-t-2.5xl',
    'last:rounded-b-2.5xl',
    'tablet-portrait:rounded-2.5xl',
    'justify-center',
    'ltr:pl-3 tablet-portrait:ltr:pl-2',
    'rtl:pr-3 tablet-portrait:rtl:pr-2',
    'cursor-pointer',
    'transition',
    'select-none',
    'relative',
    'first-child:hide-separator',
    'hover-hover:hover:hide-separator',
    ...(_vm.disabled
      ? []
      : [
          'transition-all',
          // Hover
          _vm.hoverColorClasses,
          'hover-hover:dark:hover:animate-pulse-bg-color',
          'dark:pulse-bg-from-dark-ui-200',
          'dark:pulse-bg-to-dark-ui-300',
          // Active + Focus
          'hover-hover:active:animate-none',
          'hover-hover:focus:animate-none',
          'hover-hover:dark:active:animate-none',
          'hover-hover:dark:focus:animate-none',
          'hover-hover:dark:active:bg-dark-ui-300',
          'dark:active:bg-dark-ui-300',
          'hover-hover:dark:focus:bg-dark-ui-300',
          'dark:focus:bg-dark-ui-300',
          _vm.interactionColorClasses,
          // Tap
          'hover-hover:active:text-dark-text-100',
          'hover-hover:dark:active:text-light-text-100',
          // Mobile Tap
          'active:text-dark-text-100',
          'dark:active:text-light-text-100',
        ]),
  ],on:{"click":_vm.onClick}},[(!_vm.isSmallerThanTabletPortrait)?_c('rounded-hexagon-icon',{staticClass:"flex-grow-0",attrs:{"height":48,"background-color":_vm.color,"icon-name":_vm.iconName,"icon-size":24,"image-url":_vm.imageUrl,"image-alt-text":_vm.imageAltText}}):_vm._e(),_vm._v(" "),(_vm.isSmallerThanTabletPortrait)?[(_vm.iconName)?_c('OzIcon',{staticClass:"flex-grow-0",class:_vm.mobileIconColorClasses,attrs:{"size":24,"name":_vm.iconName}}):(_vm.imageUrl)?_c('OzAvatar',{class:['flex-grow-0 rounded', _vm.mobileIconColorClasses],attrs:{"height":24,"width":24,"src":_vm.imageUrl,"alt-text-name":_vm.imageAltText}}):_vm._e()]:_vm._e(),_vm._v(" "),_c('span',{staticClass:"flex-grow ml-3 rtl:ml-0 rtl:mr-3 text-17 tablet-portrait:text-14 font-sans text-start"},[_vm._t("default")],2),_vm._v(" "),_c('span',{staticClass:"flex-grow-0 ml-6 mr-3 text-sm font-sans font-normal text-highway-300 dark:text-white-200 truncate"},[_vm._t("subtext")],2),_vm._v(" "),(_vm.isSmallerThanTabletPortrait)?_c('div',{class:[
      'separator',
      'border-solid',
      'border-highway-disabled',
      'dark:border-white-disabled',
      'border-t-0.5',
      'absolute',
      'top-0',
      'left-12',
      'right-0',
    ],attrs:{"role":"separator"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }